import { connectorAPI } from 'actions/connector'
import { CONSTS } from 'config/objectConst'

import type { AttachmentProps } from '../model/types'

export async function fetchAttachments(
	{ accepts, id, url }: AttachmentProps,
	{
		signal
	}: {
		signal?: AbortSignal
	}
) {
	const token = await connectorAPI.getAccessToken()
	const response = await fetch(
		`${CONSTS.API.URL_AUTOMATION}conversations/${id}/attachments/${encodeURIComponent(url)}`,
		{
			headers: {
				Accept: accepts,
				Authorization: token
			},
			method: 'GET',
			signal
		}
	)

	const blob = await response.blob()

	return { data: URL.createObjectURL(blob) }
}
